<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="settlementKasbon"
          :listGeneralKasbon="listGeneralKasbon"
          :listCategory="listCategory"
          ref="formEdit"
          v-if="!edit"
        ></form-edit>
        <detail
          :id="id"
          :form="settlementKasbon"
          v-if="edit"
        ></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="updateItem">
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="printPreview">
                  <v-icon>
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>Print Settlement</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="getDocument">
                  <v-icon>
                    mdi-file-document
                  </v-icon>
                </v-btn>
              </template>
              <span>List Document</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="edit && settlementKasbon.status === 'Outstanding' && !settlementKasbon.hidden"
        >
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="editItem">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="edit && settlementKasbon.status === 'Outstanding' && !settlementKasbon.hidden"
        >
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click.stop="deleteDialog">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>
                    mdi-history
                  </v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="settlementKasbon.formNumber"
      title="General Kasbon"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <dialog-document :dialog="dialogDocument" :items="items" :woIds="woIds" @close="close" />
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="SettlementKasbon"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailSettlementKasbon";
import FormEdit from "./FormSettlementKasbon";
import DialogDelete from "@/components/DialogDelete";
import DialogDocument from "../../../components/DialogDocument.vue";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "settlement-kasbon-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    DialogDocument,
    DialogAuditHistory,
  },
  props: {
    id: {
      type: Number,
      default: () => undefined,
    },
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogDocument: false,
    dialogAuditHistory: false,
    listCategory: [],
    listGeneralKasbon: [],
    items: [],
    woIds: [],
    settlementKasbon: {},
  }),
  methods: {
    async getSettlementKasbon() {
      await this.$store.dispatch("settlementKasbon/getById", this.id).then(response => {
        this.settlementKasbon = response.data;
      });
    },
    back() {
      this.$router.go(-1);
    },
    async editItem() {
      this.$store.commit("SET_LOADER", true);
      try {
        await Promise.all([this.getListGeneralKasbon(), this.getListCategory()]);
        this.edit = false;
      } catch (e) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
        });
      } finally {
        this.$store.commit("SET_LOADER", false);
      }
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    deleteItem(id) {
      this.$store.dispatch("settlementKasbon/delete", id);
      this.dialog = false;
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.dialogDocument = false;
    },
    cancel() {
      this.getSettlementKasbon();
      this.edit = true;
    },
    printPreview() {
      this.$router.push({ name: "Print Preview Settlement", params: { id: this.id } });
    },
    async getListCategory() {
      const response = await this.$store.dispatch("generalKasbon/getListCategory");
      if (response.status === 200) {
        this.listCategory = response.data;
      }
    },
    async getListGeneralKasbon() {
      const response = await this.$store.dispatch(
        "generalKasbon/getListGeneralKasbonForSettlementAll"
      );
      if (response.status === 200) {
        this.listGeneralKasbon = response.data;
      }
    },
    async getDocument() {
      this.woIds = this.settlementKasbon.wos.map(x => x.woId);
      console.log(this.woIds);
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("settlementKasbon/getDocument", this.woIds)
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
          this.dialogDocument = true;
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    getInitialData() {
      this.$store.commit("SET_LOADER", true);
      this.getSettlementKasbon()
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
